import React, { useEffect, useState } from 'react';
import { useAuth } from '../../systems/auth-context';
import { Spinner } from '../spinner';
import styles from './auth.module.css';

interface OidcCallbackProps {
  onComplete: () => void;
}

const OidcCallback: React.FC<OidcCallbackProps> = ({ onComplete }) => {
  const { login } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const errorMessage = params.get('error');

    if (errorMessage) {
      setError(decodeURIComponent(errorMessage));
      return;
    }

    let cancelled = false;
    fetch('/api/auth/me')
      .then(async (response) => {
        if (!response.ok) {
          throw new Error('Connexion SSO incomplète. Réessayez.');
        }
        const data = await response.json() as { user?: Parameters<typeof login>[0] };
        if (!data.user) {
          throw new Error('Réponse SSO invalide. Réessayez.');
        }
        if (!cancelled) {
          login(data.user);
          window.history.replaceState({}, document.title, '/');
          onComplete();
        }
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Connexion SSO incomplète. Réessayez.');
        }
      });

    return () => {
      cancelled = true;
    };
  }, [login, onComplete]);

  return (
    <div className={styles.authContainer}>
      <h2>Connexion SSO</h2>
      {error ? (
        <>
          <div className={styles.error}>{error}</div>
          <button type="button" className={styles.submitBtn} onClick={onComplete}>
            Retour à la connexion
          </button>
        </>
      ) : (
        <Spinner layout="centered" label="Finalisation de la connexion…" />
      )}
    </div>
  );
};

export default OidcCallback;
